import { FC } from "react";
import { IconPropsType } from ".";

export const PersonOutlined: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5ZM12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 12.5H11.5C9.84315 12.5 8.5 13.8431 8.5 15.5V17C8.5 17.8284 9.17157 18.5 10 18.5H14C14.8284 18.5 15.5 17.8284 15.5 17V15.5C15.5 13.8431 14.1569 12.5 12.5 12.5ZM11.5 11C9.01472 11 7 13.0147 7 15.5V17C7 18.6569 8.34315 20 10 20H14C15.6569 20 17 18.6569 17 17V15.5C17 13.0147 14.9853 11 12.5 11H11.5Z"
        fill={props.color}
      />
    </svg>
  );
};
